import { WidgetContextData } from '../widget-context.type';

export class WidgetContextDataShared {
  public static widgetContext: WidgetContextData = {
    appId: '',
    tenantId: '',
    config: {
      flowId: '',
      bundleApi: '',
      customConfig: {
        tenantId: '',
        businessUnitId: '',
        userId: ''
      }
    }
  };
}

export const widgetConfigBundleApi = (): string => {
  const context = WidgetContextDataShared.widgetContext;
  return context?.config?.bundleApi;
};
